<template>
  <div class="content">
    <Header :title="'找回密码'" />
    <nut-row>
      <div class="logo-wrap">
        <div class="logo">
          <img alt src="@/assets/images/logo.png">
        </div>
      </div>
    </nut-row>
    <nut-row>
      <!-- 找回密码 -->
      <div class="form-wrap">
        <div class="my-row">
          <nut-textinput
            v-model="phone"
            :clear-btn="true"
            :disabled="false"
            :has-border="false"
            autocomplete="off"
            placeholder="输入11位手机号码"
            type="number"
          />
        </div>
        <div class="my-row">
          <div class="code-txt">
            <nut-textinput
              v-model="validateOldCode"
              :has-border="false"
              autocomplete="off"
              maxlength="4"
              placeholder="验证码"
              type="text"
            />
          </div>
          <div class="code-btn">
            <nut-button v-show="showSend" block @click="getCode">获取验证码</nut-button>
          </div>
          <div class="code-btn code-count">
            <nut-button v-show="!showSend" :disabled="true" block>{{ countDown }}s后重新获取</nut-button>
          </div>
        </div>
        <div class="my-row">
          <nut-textinput
            v-model="oldPwd"
            :clear-btn="false"
            :disabled="false"
            :has-border="false"
            :type="inputType"
            autocomplete="off"
            maxlength="20"
            placeholder="输入新密码"
            @focus="inputFocus()"
          />
          <div v-show="toggleShow" @click="toggleEye()">
            <i v-show="eyeShow" class="iconfont eyes-open">&#xe745;</i>
            <i v-show="!eyeShow" class="iconfont eyes-close">&#xe6a3;</i>
          </div>
        </div>
        <div class="my-row">
          <nut-textinput
            v-model="newPwd"
            :clear-btn="false"
            :disabled="false"
            :has-border="false"
            :type="inputType2"
            autocomplete="off"
            maxlength="20"
            placeholder="确认新密码"
            @focus="inputFocus2()"
          />
          <div v-show="toggleShow2" @click="toggleEye2()">
            <i v-show="eyeShow2" class="iconfont eyes-open">&#xe745;</i>
            <i v-show="!eyeShow2" class="iconfont eyes-close">&#xe6a3;</i>
          </div>
        </div>
        <div class="my-row btn">
          <nut-button block @click="findPwd">找回密码</nut-button>
        </div>
        <div class="my-row">
          <p class="login">
            <router-link to="/Account/Login">登 录</router-link>
          </p>
        </div>
      </div>
    </nut-row>
  </div>
</template>
<script>
import { resetPassword, sendFindPasswordCode } from '@/api/Account/index'
import { Toast } from '@nutui/nutui'
import Storage from '@/utils/storage'
import Header from '@/components/Header/Index'

export default {
  name: 'FindPwd',
  components: {
    Header
  },
  data() {
    return {
      phone: '',
      validateOldCode: '',
      oldPwd: '',
      newPwd: '',
      showSend: true,
      countDown: '',
      timer: null,
      eyeShow: false,
      eyeShow2: false,
      toggleShow: false,
      toggleShow2: false
    }
  },
  computed: {
    inputType() {
      return this.eyeShow ? 'text' : 'password'
    },
    inputType2() {
      return this.eyeShow2 ? 'text' : 'password'
    }
  },
  methods: {
    getCode() {
      const _this = this
      if (this.phone === '') {
        Toast.text('请输入手机号码')
        return
      }
      if (this.$isPhone(_this.phone) === false) {
        Toast.text('请输入正确手机号码')
        return
      }
      const TIME_COUNT = 60
      if (!this.timer) {
        this.countDown = TIME_COUNT
        this.showSend = false
        this.timer = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= TIME_COUNT) {
            this.countDown--
          } else {
            this.showSend = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
      sendFindPasswordCode(this.phone).then(res => {
        if (res && res.success) {
          Toast.success('验证码发送成功')
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    findPwd() {
      const _this = this
      if (this.phone === '') {
        Toast.text('请输入手机号码')
        return
      }
      if (this.$isPhone(_this.phone) === false) {
        Toast.text('请输入正确手机号码')
        return
      }
      if (this.validateOldCode === '') {
        Toast.text('请输入验证码')
        return
      }
      if (this.oldPwd === '') {
        Toast.text('请输入密码')
        return
      }
      if (this.oldPwd.length < 6) {
        Toast.text('请输入6位以上密码')
        return
      }
      if (this.newPwd === '') {
        Toast.text('请确认密码')
        return
      }
      if (this.newPwd !== this.oldPwd) {
        Toast.text('两次密码不一致！')
        return
      }
      const params = {
        code: this.validateOldCode.trim(),
        phone: this.phone,
        password: this.oldPwd
      }
      resetPassword(params).then(res => {
        if (res && res.success) {
          Toast.success('密码修改成功，请登录')
          this.validateOldCode = ''
          this.oldPwd = ''
          this.newPwd = ''
          Storage.localSet('phone', _this.phone)
          this.$router.push({
            path: '/Account/Login'
          })
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 小眼睛可见性切换
    toggleEye() {
      this.eyeShow = !this.eyeShow
    },
    toggleEye2() {
      this.eyeShow2 = !this.eyeShow2
    },
    // 监听input的focus
    inputFocus() {
      this.toggleShow = true
    },
    inputFocus2() {
      this.toggleShow2 = true
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep .nut-textinput input {
  height: 42px;
  line-height: 42px;
}

::v-deep .nut-button {
  background: #dc9a10;
  border-radius: 5px;
  -webkit-appearance: none;
  height: 42px;
  line-height: 42px;
  padding: 0 5px;
}

::v-deep .nut-button[disabled] {
  background: #dadada;
}

::v-deep .nut-checkbox input:checked {
  background-color: #dc9a10;
  background-repeat: no-repeat;
  background-position: center;
  border-color: #dc9a10;
  background-size: 60%;
  box-shadow: 0 4px 6px 0 rgba(220, 154, 15, 0.15);
}

::v-deep .nut-button.circle {
  border-radius: 50px;
  background: transparent;
  color: #808080;
  border: 1px solid #cccccc;
  height: 35px;
  line-height: 35px;
  font-size: 13px;
}

::v-deep .van-picker {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
}

::v-deep .nut-checkbox {
  margin-right: 0px;
}

.content {
  width: 100vw;
  min-height: 100vh;
  height: auto;
  overflow: hidden;
  background-image: url('~@/assets/images/login-bg.png');
  background-size: 100% 100%;

  .logo-wrap {
    width: 100%;
    height: 135px;
    position: relative;
    box-sizing: border-box;
    padding: 35px 0;

    .logo {
      width: 100%;
      height: 79px;
      display: flex;
      justify-content: center;

      img {
        width: 104px;
      }
    }
  }

  .form-wrap {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0px 23px 0 23px;
    box-sizing: border-box;

    .my-row {
      margin-bottom: 18px;
      color: #80765d;
      position: relative;
      margin-top: 10px;
      font-size: 14px;

      .eyes-open {
        position: absolute;
        right: 5px;
        top: 9px;
        font-size: 24px;
        color: #999999;
      }

      .eyes-close {
        position: absolute;
        right: 10px;
        top: 15px;
        font-size: 16px;
        color: #999999;
      }

      .code-txt {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding-right: 105px;
      }

      .code-btn {
        position: absolute;
        right: 0;
        top: 0;
        width: 90px;
      }

      .code-count {
        width: 105px;
      }

      &.next-step {
        margin-top: 55px;
      }

      .login {
        text-align: center;
        font-size: 14px;

        a {
          text-decoration: underline;
          color: #875320;
        }
      }

      .chose-city {
        position: relative;
        width: 100%;
        height: 44px;
        background: #ffffff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0 20px;
        line-height: 44px;
        font-size: 12px;

        .txt-adress {
          position: absolute;
          left: 20px;
          color: #d4d4d4;
        }

        .txt-wrap {
          width: 100%;
          position: relative;
          padding-left: 40px;
          box-sizing: border-box;

          .txt {
            width: 100%;
            color: #7c7c7c;
            text-align: right;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .my-row.btn {
      margin-top: 25px;
    }
  }
}
</style>
